import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

const FNOLTooltip = (props) => (
  <div className="d-inline">
    <i data-for={props.dataFor} data-tip={props.content} style={{ color: 'black' }} className="fa fa-info-circle" aria-hidden="true"></i>
    <ReactTooltip
      id={props.dataFor}
      multiline
      place={props.place || 'right'}
      type={props.type || 'dark'}
      effect={props.effect || 'solid'}
      className="tooltipBackgroundColor"
    />
  </div>
  )
;

FNOLTooltip.propTypes = {
  place: PropTypes.string,
  type: PropTypes.string,
  effect: PropTypes.string,
  content: PropTypes.string,
  dataFor: PropTypes.any,
};
export default FNOLTooltip;



// WEBPACK FOOTER //
// ./app/components/FNOLTooltip/index.js